// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__tsJ9I","spin":"Spinner_spin__3UhJC"};